import { Text } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/tag";
import { VeiculoItem } from "core/features/veiculo/typings";
import { CoresVeiculo } from "core/features/veiculo/veiculo.data";
import { useMemo } from "react";

function useTabelaVeiculosColumns() {
  return useMemo(() => {
    return [
      {
        title: "Marca e Modelo",
        render: (veiculo: VeiculoItem) => (
          <Text>
            {veiculo.marcaVeiculo.nome} {veiculo.modeloVeiculo.nome}
          </Text>
        ),
      },
      {
        title: "Placa",
        dataIndex: "placa",
        render: (placa: string) => {
          return (
            <Flex>
              <Tag variant="outline" colorScheme="orange" size="sm">
                {placa}
              </Tag>
            </Flex>
          );
        },
      },
      {
        title: "Cor",
        dataIndex: "cor",
        render: (cor: string) => {
          return (
            <Flex>
              <Tag variant="outline" colorScheme="blue" size="sm">
                {CoresVeiculo.find((c) => c.value === cor)?.label || "--"}
              </Tag>
            </Flex>
          );
        },
      },
    ];
  }, []);
}

export default useTabelaVeiculosColumns;
